import { CROSS_BREAKPOINT, LARGE } from '../breakpoint-controller';
export const CHANGED_FILTER = 'changed-filter';

const $ = jQuery;
let el = null;

function onDocumentReady() {
	el = $('#university-grid').length > 0 ? $('#university-grid') : jQuery('#content-exchange-sidebar');
	if (el) {
		initialize();
	}
}

function initialize() {
	el.on('click', 'input[name]', onClickFilterItem);
	el.on('click', '.content-exchange__filter--reset', onClickResetFilter);
	el.on('click', '.toggle-more', onClickToggleMore);

	$(document).on(CROSS_BREAKPOINT, onCrossBreakpoint);
}

function onCrossBreakpoint(e, breakpoint) {
	el.off('click', '.toggle-filter', onClickToggleFilter);
	if (breakpoint < LARGE) {
		el.on('click', '.toggle-filter', onClickToggleFilter);
	}
}

function onClickToggleFilter() {
	el
		.find('.tag-group')
		.stop(true, true)
		.slideToggle();
}

function onClickToggleMore(e) {
	let clicked = $(e.currentTarget);
	let buttonText = clicked.text();
	let tags = clicked.prev('.tag-group-tags');

	tags.toggleClass('not-expanded expanded');

	if (tags.hasClass('expanded')) {
		buttonText = buttonText.replace('More', 'Fewer');
	} else {
		buttonText = buttonText.replace('Fewer', 'More');
	}

	clicked.text(buttonText);

	e.preventDefault();
	return false;
}

function onClickResetFilter(e) {
	let checked = el.find('input[name]:checked');

	if (checked.length > 0) {
		checked.prop('checked', false);
		el.trigger(CHANGED_FILTER);
	}
}

function onClickFilterItem(e) {
	el.trigger(CHANGED_FILTER);
}

export function getFilterState() {
	let ret = [];

	if (el) {
		ret = el
			.find('input[name]:checked')
			.toArray()
			.map(i => i.value);
	}

	return ret;
}

export function setFilterState(filterState) {
	if (el) {
		el
			.find('input[name]')
			.toArray()
			.forEach(c => (c.checked = filterState.includes(c.value)));
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
